export const colors = [
  "#7d4f28",
  "#793dd3",
  "#3b215a",
  "#70e496",
  "#d6448f",
  "#52aa43",
  "#9b4298",
  "#91a83f",
  "#57549c",
  "#df9728",
  "#6688d5",
  "#e05d23",
  "#6de6d1",
  "#97e143",
  "#d150d2",
  "#5ade57",
  "#4b248e",
  "#d1e34f",
  "#6f6be0",
  "#dec748",
  "#dd3233",
  "#59bbcf",
  "#d23b5f",
  "#51af88",
  "#7d2a54",
  "#c6e49f",
  "#31172b",
  "#c4e1d7",
  "#983524",
  "#95b4de",
  "#e36a57",
  "#37712e",
  "#d092d2",
  "#957f30",
  "#304158",
  "#daa767",
  "#5b7896",
  "#c87945",
  "#233b25",
  "#d37783",
  "#427467",
  "#682726",
  "#d2c18f",
  "#453324",
  "#dbb0ba",
  "#535824",
  "#875e7a",
  "#7a935b",
  "#987868",
  "#8da89b",
];
